export const nodeNameBackwardsCompatibility = {
  textInput: "textbox",
};
